
import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LoginContext } from "./contexts/LoginContext";


const ProtectedRoute = (props) => {
    const { Component } = props
    const navigate = useNavigate();
    const { setUserName, UserName, setEmailC, setProviderId, setUserId, setUserType, isDefaultSplash, providerDetails } =
        useContext(LoginContext);
    const { id } = useParams();
    const location = useLocation();
    const domain = window.location.hostname;;
    console.log(id, "idis");
    useEffect(() => {
        let login = sessionStorage.getItem('login');
        console.log(login);
        let loginAuth = sessionStorage.getItem('PersonalInfo')
        window.onbeforeunload = function () {
            sessionStorage.clear();
        };
        console.log('providerDetails', providerDetails, isDefaultSplash, 'isDefaultSplash1', isDefaultSplash == false)
        if (!login && providerDetails?.logoutUrl) {
            navigate(`/signin/${providerDetails?.providerKey}`);
            window.location.href = providerDetails?.logoutUrl
            // return
        } else if (!login && location.pathname !== '/' && location.pathname !== '/medineer') {
            // if (isDefaultSplash == false) {
            //     navigate('/medineer')   //(/medineer)
            // } else {
            //     // navigate('/')
            //     navigate(`/letStart`);
            // }
            if (domain.includes('localhost')) {
                navigate('/letsStart', { replace: true });
            } else if (domain.includes('127.0.0.1')) {
                navigate('/medineer', { replace: true });
            } else if (domain.includes('learner.learningfitbit.com')) {
                navigate('/letsStart', { replace: true });
            } else if (domain.includes('medineer.ai')) {
                navigate('/medineer', { replace: true });
            } else if (domain.includes('live-assess-ui-demo.azurewebsites.net')) {
                navigate('/medineer', { replace: true });
            } else if (domain.includes('live-assess-ui.azurewebsites.net')) {
                navigate('/medineer', { replace: true })
            }

        }

        // if(loginAuth){
        //     // setProviderId(loginAuth.providerId)
        //     // setUserId(loginAuth.userId)
        //     // setUserName(loginAuth.fullName)
        //     // setEmailC(loginAuth.email)
        //     navigate('/Home')
        // }
        else {
            if (id) {
                console.log('navigate to provider signin')
                navigate('/signIn/' + id)
            }
        }
    }, [])

    return (
        <div>
            <Component />
        </div>
    )
}
export default ProtectedRoute;